import axios from "axios";
export default {
  state: {
    uploadProgress: 0
  },
  getters: {

  },
  mutations: {
    SET_UPLOAD_PROGRESS(state, uploadProgress) {
      state.uploadProgress = uploadProgress
    }
  },
  actions: {
    async loadLesson( _, params){
      return await axios.get('/lessons', { params })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async loadLessonDetail( _, id){
      return await axios.get(`/lessons/${id}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async createLesson( { commit  }, formData){
      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          commit('SET_UPLOAD_PROGRESS', percentCompleted)
        }
      }
      return await axios.post('/lessons', formData, config)
      .then(response => {
        commit('SET_UPLOAD_PROGRESS', 0)
        return Promise.resolve(response);
      })
      .catch(errors => {
        commit('SET_UPLOAD_PROGRESS', 0)
        return Promise.reject(errors.response)
      })
    },
    async updateLesson( { commit }, {id, formData}){
      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          commit('SET_UPLOAD_PROGRESS', percentCompleted)
        }
      }
      return await axios.post(`/lessons/${id}`, formData, config)
      .then(response => {
        commit('SET_UPLOAD_PROGRESS', 0)
        return Promise.resolve(response);
      })
      .catch(errors => {
        commit('SET_UPLOAD_PROGRESS', 0)
        return Promise.reject(errors.response)
      })
    },
    async deleteLesson( _, id){
      return await axios.delete(`/lessons/${id}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async destroyVideo( _, id){
      return await axios.delete(`/lesson-videos/${id}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateLessonOrder(_, formData){
      return await axios.post(`/lessons/order`, formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    }
  },
};